export const PAYMENT_METHOD_UPDATE = 'pyo_payment_method_update';

// Annotation type constants
export const ANNOTATION_TYPES = {
    PAY_FIXUP: "PayFixup",
    UPDATE_PAYMENT_METHOD: "UpdatePaymentMethod",
    CANCEL: "Cancel",
    REPLACED_BY: "ReplacedBy",
    REPLACES: "Replaces",
    ITEM_CANCELLED_ON: "ItemCancelledOn",
    SUPPRESS_PAY_FIXUP: "SuppressPayFixup",
    REFUND: "Refund",
    MANUFACTURER_CHANGED: "ManufacturerChanged",
} as const;

// Annotation filter sets for DeliveryCard
export const IGNORED_ANNOTATIONS_FOR_SUMMARIES = new Set<string>([
    ANNOTATION_TYPES.UPDATE_PAYMENT_METHOD,
    ANNOTATION_TYPES.CANCEL,
    ANNOTATION_TYPES.ITEM_CANCELLED_ON,
    ANNOTATION_TYPES.REPLACES,
    ANNOTATION_TYPES.REPLACED_BY,
]);

export const IGNORED_ANNOTATIONS_FOR_GROUPS = new Set<string>([
    ANNOTATION_TYPES.UPDATE_PAYMENT_METHOD,
    ANNOTATION_TYPES.CANCEL,
    ANNOTATION_TYPES.ITEM_CANCELLED_ON,
    ANNOTATION_TYPES.PAY_FIXUP,
]);

export const ALLOWED_PILLPACK_ANNOTATIONS = new Set<string>([
    ANNOTATION_TYPES.REFUND,
    ANNOTATION_TYPES.REPLACES,
    ANNOTATION_TYPES.REPLACED_BY,
]);
